import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as Sentry from '@sentry/react';

import {
  Webform as WebformComponent,
} from '@uncinc/react-drupal-core';

import {
  getAdditionalWebformElementsInfo,
} from '../../store/actions/UI';

import './style.scss';

const Webform = (props) => {
  const { id } = props;
  const dispatch = useDispatch();

  const webformHasSelectLimitHandler = useSelector((state) => state.getIn(['webform', id, 'info', 'handlers', 'options_checkbox_limit'], false));

  const onFailedSubmit = (data) => {
    if (data instanceof Error) {
      // Network error or similar.
      Sentry.captureException(data);
    } else {
      // Webform error. Only get the keys, since the values may contain personal data.
      Sentry.withScope((scope) => {
        const dataSanitized = JSON.stringify(Object.keys(data));
        scope.setExtra('fields', dataSanitized);
        Sentry.captureException(new Error('Webform submission error due to invalid values'));
      });
    }
  }

  // If this webform has the SelectLimit handler, then we need additional field data
  useEffect(() => {
    if (webformHasSelectLimitHandler !== false) {
      dispatch(getAdditionalWebformElementsInfo(id));
    }
  }, [dispatch, webformHasSelectLimitHandler]);

  return (
    <div className="Webform__wrapper">
      <WebformComponent
        onFailedSubmit={onFailedSubmit}
        {...props}
      />
    </div>
  );
};

export default Webform;
